import { Banner } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { editTag } from 'src/api/queries';
import { toTitleCase } from 'src/components/UserRegistrationSteps/StepThree/signupHook';
import TagForm, { ITagFormData } from './TagForm';

export type ITagDefaultValue = {
  isOpen: boolean;
  tagId: string;
  name: string;
  description: string;
  usage: string;
  submissionContextId?: string;
  tagCategoryId?: string;
  tagColor: string;
  tagCategory: string;
  tagDescription: string;
};

interface Props {
  onClose: () => void;
  defaultValue: ITagDefaultValue;
  workspaceId: string;
  usage: string;
}

const EditTag: React.FC<Props> = ({
  onClose,
  defaultValue,
  workspaceId,
  usage
}) => {
  const title = toTitleCase(usage)?.slice(0, -1);

  const { data: tagCount } = useQuery({
    queryKey: ['edit-tag', { workspaceId, tagId: defaultValue.tagId }],
    queryFn: () =>
      defaultValue.tagId ? editTag(workspaceId, defaultValue.tagId) : null
  });

  const bannerHeading = `Editing this tag will update ${
    tagCount?.count ?? '0'
  } ${
    defaultValue?.usage
      ? defaultValue.usage.replace(
          /^\w+/,
          word => word.charAt(0).toUpperCase() + word.slice(1)
        )
      : ''
  }.`;

  const initialValues: Partial<ITagFormData> = {
    name: defaultValue.name,
    description: defaultValue.description,
    usage: defaultValue.usage,
    submissionContextId: defaultValue.submissionContextId || '',
    tagCategoryId: defaultValue.tagCategoryId || '',
    tagCategory: defaultValue.tagCategory,
    tagColor: defaultValue.tagColor,
    tagDescription: defaultValue.tagDescription
  };

  return (
    <TagForm
      mode="edit"
      onClose={onClose}
      workspaceId={workspaceId}
      usage={usage}
      tagId={defaultValue.tagId}
      defaultValues={initialValues}
      headingTitle={`Edit ${title} Tag`}
      backButtonLabel={`Back to ${title} Tags`}
      submitButtonLabel="Save Tag"
      successToastTitle="Tag Edits Saved"
      topContent={
        <Banner
          customIcon={<FontAwesomeIcon icon={faCircleInfo} />}
          heading={bannerHeading}
          variant="attention"
        />
      }
    />
  );
};

export default EditTag;
